module.exports = __webpack_public_path__ + "ComputerDesk___1BA9v.svg";